var map = {
	"./audio/avengers.webm": "1b66",
	"./audio/familyguy.webm": "d209",
	"./audio/ffvii.webm": "96d9",
	"./audio/friends.webm": "f76a",
	"./audio/got.webm": "5537",
	"./audio/mario.webm": "66f7",
	"./audio/naruto.webm": "0359",
	"./audio/pokemon.webm": "9ec3",
	"./audio/pokemon2.webm": "8085",
	"./audio/rick.webm": "e4f8",
	"./audio/sf.webm": "081e",
	"./audio/sonic.webm": "ab34",
	"./audio/soulc.webm": "c720",
	"./audio/starfox.webm": "6cc5",
	"./audio/tbbt.webm": "8c7d",
	"./audio/tekken.webm": "bc2c",
	"./audio/zelda.webm": "5ad0",
	"./cards/avengers": "1600",
	"./cards/avengers.json": "1600",
	"./cards/familyguy": "f649",
	"./cards/familyguy.json": "f649",
	"./cards/ffvii": "6208",
	"./cards/ffvii.json": "6208",
	"./cards/friends": "5153",
	"./cards/friends.json": "5153",
	"./cards/got": "fec7",
	"./cards/got.json": "fec7",
	"./cards/mario": "beb4",
	"./cards/mario.json": "beb4",
	"./cards/naruto": "e673",
	"./cards/naruto.json": "e673",
	"./cards/pokemon": "d871",
	"./cards/pokemon.json": "d871",
	"./cards/pokemon2": "e44f",
	"./cards/pokemon2.json": "e44f",
	"./cards/rick": "6432",
	"./cards/rick.json": "6432",
	"./cards/sf": "3c46",
	"./cards/sf.json": "3c46",
	"./cards/sonic": "34f3",
	"./cards/sonic.json": "34f3",
	"./cards/soulc": "564f",
	"./cards/soulc.json": "564f",
	"./cards/starfox": "c76a",
	"./cards/starfox.json": "c76a",
	"./cards/tbbt": "1449",
	"./cards/tbbt.json": "1449",
	"./cards/tekken": "c65d",
	"./cards/tekken.json": "c65d",
	"./cards/zelda": "f661",
	"./cards/zelda.json": "f661",
	"./images/avengers/bg/1.png.webp": "89b4",
	"./images/avengers/bg/10.png.webp": "83eb",
	"./images/avengers/bg/11.png.webp": "3b98",
	"./images/avengers/bg/12.png.webp": "f98f",
	"./images/avengers/bg/13.png.webp": "d04f",
	"./images/avengers/bg/14.png.webp": "ddd6",
	"./images/avengers/bg/15.png.webp": "e3aa",
	"./images/avengers/bg/16.png.webp": "8b72",
	"./images/avengers/bg/2.png.webp": "4d85",
	"./images/avengers/bg/3.png.webp": "c8ca",
	"./images/avengers/bg/4.png.webp": "4597",
	"./images/avengers/bg/5.png.webp": "de90",
	"./images/avengers/bg/6.png.webp": "2466",
	"./images/avengers/bg/7.png.webp": "4689",
	"./images/avengers/bg/8.png.webp": "d0df",
	"./images/avengers/bg/9.png.webp": "bce8",
	"./images/avengers/main/1.png.webp": "88e4",
	"./images/avengers/main/2.png.webp": "f274",
	"./images/avengers/main/3.png.webp": "cf97",
	"./images/avengers/main/4.png.webp": "6219",
	"./images/avengers/main/5.png.webp": "94c7",
	"./images/avengers/main/6.png.webp": "c863",
	"./images/avengers/main/7.png.webp": "b199",
	"./images/avengers/main/8.png.webp": "c409",
	"./images/familyguy/bg/1.png.webp": "89af",
	"./images/familyguy/bg/10.png.webp": "9648",
	"./images/familyguy/bg/11.png.webp": "3986",
	"./images/familyguy/bg/12.png.webp": "af43",
	"./images/familyguy/bg/13.png.webp": "45f7",
	"./images/familyguy/bg/14.png.webp": "8838",
	"./images/familyguy/bg/15.png.webp": "b9bc",
	"./images/familyguy/bg/16.png.webp": "41ee",
	"./images/familyguy/bg/2.png.webp": "6b4f",
	"./images/familyguy/bg/3.png.webp": "98e8",
	"./images/familyguy/bg/4.png.webp": "ac4e",
	"./images/familyguy/bg/5.png.webp": "7a47",
	"./images/familyguy/bg/6.png.webp": "8347",
	"./images/familyguy/bg/7.png.webp": "b5c2",
	"./images/familyguy/bg/8.png.webp": "b49d",
	"./images/familyguy/bg/9.png.webp": "d580",
	"./images/familyguy/main/1.png.webp": "ea86",
	"./images/familyguy/main/2.png.webp": "186d",
	"./images/familyguy/main/3.png.webp": "0f1d",
	"./images/familyguy/main/4.png.webp": "9730",
	"./images/familyguy/main/5.png.webp": "71d2",
	"./images/familyguy/main/6.png.webp": "f0cc",
	"./images/familyguy/main/7.png.webp": "15f8",
	"./images/familyguy/main/8.png.webp": "6712",
	"./images/ffvii/bg/1.png.webp": "eb9f",
	"./images/ffvii/bg/10.png.webp": "8a50",
	"./images/ffvii/bg/11.png.webp": "c820",
	"./images/ffvii/bg/12.png.webp": "ef83",
	"./images/ffvii/bg/13.png.webp": "4df8",
	"./images/ffvii/bg/14.png.webp": "b983",
	"./images/ffvii/bg/15.png.webp": "4bf3",
	"./images/ffvii/bg/16.png.webp": "33de",
	"./images/ffvii/bg/2.png.webp": "1a9b",
	"./images/ffvii/bg/3.png.webp": "21f6",
	"./images/ffvii/bg/4.png.webp": "facd",
	"./images/ffvii/bg/5.png.webp": "7b9c",
	"./images/ffvii/bg/6.png.webp": "babb",
	"./images/ffvii/bg/7.png.webp": "eaed",
	"./images/ffvii/bg/8.png.webp": "6879",
	"./images/ffvii/bg/9.png.webp": "ebfb",
	"./images/ffvii/main/1.png.webp": "6499",
	"./images/ffvii/main/2.png.webp": "2978",
	"./images/ffvii/main/3.png.webp": "d23d",
	"./images/ffvii/main/4.png.webp": "427e",
	"./images/ffvii/main/5.png.webp": "759a",
	"./images/ffvii/main/6.png.webp": "8335",
	"./images/ffvii/main/7.png.webp": "96486",
	"./images/ffvii/main/8.png.webp": "2c37",
	"./images/friends/bg/1.png.webp": "d4ff",
	"./images/friends/bg/10.png.webp": "bb15",
	"./images/friends/bg/11.png.webp": "24ed",
	"./images/friends/bg/12.png.webp": "bace",
	"./images/friends/bg/13.png.webp": "b5e7",
	"./images/friends/bg/14.png.webp": "c30b",
	"./images/friends/bg/15.png.webp": "9600",
	"./images/friends/bg/16.png.webp": "bcd4",
	"./images/friends/bg/2.png.webp": "e294",
	"./images/friends/bg/3.png.webp": "a2cb",
	"./images/friends/bg/4.png.webp": "6353",
	"./images/friends/bg/5.png.webp": "e15e",
	"./images/friends/bg/6.png.webp": "ad99",
	"./images/friends/bg/7.png.webp": "08de",
	"./images/friends/bg/8.png.webp": "9329",
	"./images/friends/bg/9.png.webp": "33ee",
	"./images/friends/main/1.png.webp": "b6f9",
	"./images/friends/main/2.png.webp": "8284",
	"./images/friends/main/3.png.webp": "353d",
	"./images/friends/main/4.png.webp": "fdc7",
	"./images/friends/main/5.png.webp": "b016",
	"./images/friends/main/6.png.webp": "5308",
	"./images/friends/main/7.png.webp": "7867",
	"./images/friends/main/8.png.webp": "bd6a",
	"./images/got/bg/1.png.webp": "4991",
	"./images/got/bg/10.png.webp": "2b94",
	"./images/got/bg/11.png.webp": "f59a",
	"./images/got/bg/12.png.webp": "ac97",
	"./images/got/bg/13.png.webp": "33f3",
	"./images/got/bg/14.png.webp": "54f5",
	"./images/got/bg/15.png.webp": "17d3",
	"./images/got/bg/16.png.webp": "7c3b",
	"./images/got/bg/2.png.webp": "e846",
	"./images/got/bg/3.png.webp": "d4ae",
	"./images/got/bg/4.png.webp": "fd4f",
	"./images/got/bg/5.png.webp": "a224",
	"./images/got/bg/6.png.webp": "ba15",
	"./images/got/bg/7.png.webp": "e066",
	"./images/got/bg/8.png.webp": "4fdc",
	"./images/got/bg/9.png.webp": "f28b",
	"./images/got/main/1.png.webp": "bfc6",
	"./images/got/main/2.png.webp": "2057",
	"./images/got/main/3.png.webp": "69f4",
	"./images/got/main/4.png.webp": "60e6",
	"./images/got/main/5.png.webp": "ed72",
	"./images/got/main/6.png.webp": "1c7f",
	"./images/got/main/7.png.webp": "8a75",
	"./images/got/main/8.png.webp": "3d37",
	"./images/mario/bg/1.png.webp": "bb17",
	"./images/mario/bg/10.png.webp": "2020",
	"./images/mario/bg/11.png.webp": "6648",
	"./images/mario/bg/12.png.webp": "e094",
	"./images/mario/bg/13.png.webp": "29786",
	"./images/mario/bg/14.png.webp": "4ebe",
	"./images/mario/bg/15.png.webp": "0e82",
	"./images/mario/bg/16.png.webp": "fe3c",
	"./images/mario/bg/2.png.webp": "d1e1",
	"./images/mario/bg/3.png.webp": "6fee",
	"./images/mario/bg/4.png.webp": "8036",
	"./images/mario/bg/5.png.webp": "3a15",
	"./images/mario/bg/6.png.webp": "ef13",
	"./images/mario/bg/7.png.webp": "33ad",
	"./images/mario/bg/8.png.webp": "d6e0",
	"./images/mario/bg/9.png.webp": "5585",
	"./images/mario/main/1.png.webp": "825a7",
	"./images/mario/main/2.png.webp": "f211",
	"./images/mario/main/3.png.webp": "99f3",
	"./images/mario/main/4.png.webp": "a5fa",
	"./images/mario/main/5.png.webp": "a703",
	"./images/mario/main/6.png.webp": "45c6",
	"./images/mario/main/7.png.webp": "eb9b",
	"./images/mario/main/8.png.webp": "45e7",
	"./images/naruto/bg/1.png.webp": "1423",
	"./images/naruto/bg/10.png.webp": "58d7",
	"./images/naruto/bg/11.png.webp": "310a",
	"./images/naruto/bg/12.png.webp": "a8dc",
	"./images/naruto/bg/13.png.webp": "55da",
	"./images/naruto/bg/14.png.webp": "abb9",
	"./images/naruto/bg/15.png.webp": "4225",
	"./images/naruto/bg/16.png.webp": "886b",
	"./images/naruto/bg/2.png.webp": "824e",
	"./images/naruto/bg/3.png.webp": "90f0",
	"./images/naruto/bg/4.png.webp": "98da",
	"./images/naruto/bg/5.png.webp": "8daf",
	"./images/naruto/bg/6.png.webp": "19a8",
	"./images/naruto/bg/7.png.webp": "fbf4",
	"./images/naruto/bg/8.png.webp": "251f",
	"./images/naruto/bg/9.png.webp": "1fa9",
	"./images/naruto/main/1.png.webp": "e01d",
	"./images/naruto/main/2.png.webp": "a608",
	"./images/naruto/main/3.png.webp": "9144",
	"./images/naruto/main/4.png.webp": "f4f3",
	"./images/naruto/main/5.png.webp": "9273",
	"./images/naruto/main/6.png.webp": "021a",
	"./images/naruto/main/7.png.webp": "06ba",
	"./images/naruto/main/8.png.webp": "9550",
	"./images/pokemon/bg/1.png.webp": "206b",
	"./images/pokemon/bg/10.png.webp": "747b",
	"./images/pokemon/bg/11.png.webp": "7543",
	"./images/pokemon/bg/12.png.webp": "94ea",
	"./images/pokemon/bg/13.png.webp": "5e12",
	"./images/pokemon/bg/14.png.webp": "8327",
	"./images/pokemon/bg/15.png.webp": "c0b0",
	"./images/pokemon/bg/16.png.webp": "9b73",
	"./images/pokemon/bg/2.png.webp": "563c",
	"./images/pokemon/bg/3.png.webp": "60b9",
	"./images/pokemon/bg/4.png.webp": "ea5a",
	"./images/pokemon/bg/5.png.webp": "01ba",
	"./images/pokemon/bg/6.png.webp": "b8be",
	"./images/pokemon/bg/7.png.webp": "c6ec",
	"./images/pokemon/bg/8.png.webp": "0c1e",
	"./images/pokemon/bg/9.png.webp": "2dfa",
	"./images/pokemon/main/1.png.webp": "4880",
	"./images/pokemon/main/2.png.webp": "652b",
	"./images/pokemon/main/3.png.webp": "84d5",
	"./images/pokemon/main/4.png.webp": "e855",
	"./images/pokemon/main/5.png.webp": "ee0b",
	"./images/pokemon/main/6.png.webp": "aacc",
	"./images/pokemon/main/7.png.webp": "f12f",
	"./images/pokemon/main/8.png.webp": "23af",
	"./images/pokemon2/bg/1.png.webp": "702c",
	"./images/pokemon2/bg/10.png.webp": "5ed0",
	"./images/pokemon2/bg/11.png.webp": "12ba",
	"./images/pokemon2/bg/12.png.webp": "fb1f",
	"./images/pokemon2/bg/13.png.webp": "21cb",
	"./images/pokemon2/bg/14.png.webp": "1e79",
	"./images/pokemon2/bg/15.png.webp": "274e",
	"./images/pokemon2/bg/16.png.webp": "b024",
	"./images/pokemon2/bg/2.png.webp": "7e31",
	"./images/pokemon2/bg/3.png.webp": "8b71",
	"./images/pokemon2/bg/4.png.webp": "3849",
	"./images/pokemon2/bg/5.png.webp": "a878",
	"./images/pokemon2/bg/6.png.webp": "6571",
	"./images/pokemon2/bg/7.png.webp": "acbc",
	"./images/pokemon2/bg/8.png.webp": "8210",
	"./images/pokemon2/bg/9.png.webp": "87f9",
	"./images/pokemon2/main/1.png.webp": "f5fb",
	"./images/pokemon2/main/2.png.webp": "4a61",
	"./images/pokemon2/main/3.png.webp": "9cdf",
	"./images/pokemon2/main/4.png.webp": "b332",
	"./images/pokemon2/main/5.png.webp": "5fdf",
	"./images/pokemon2/main/6.png.webp": "a7a8",
	"./images/pokemon2/main/7.png.webp": "7e5a",
	"./images/pokemon2/main/8.png.webp": "236a",
	"./images/rick/bg/1.png.webp": "340d",
	"./images/rick/bg/10.png.webp": "afe3",
	"./images/rick/bg/11.png.webp": "172f",
	"./images/rick/bg/12.png.webp": "49c3",
	"./images/rick/bg/13.png.webp": "c744",
	"./images/rick/bg/14.png.webp": "7f60",
	"./images/rick/bg/15.png.webp": "e709",
	"./images/rick/bg/16.png.webp": "5ce0",
	"./images/rick/bg/2.png.webp": "71b1",
	"./images/rick/bg/3.png.webp": "b5f8",
	"./images/rick/bg/4.png.webp": "f33f",
	"./images/rick/bg/5.png.webp": "fb32",
	"./images/rick/bg/6.png.webp": "4df1",
	"./images/rick/bg/7.png.webp": "520f",
	"./images/rick/bg/8.png.webp": "06ce",
	"./images/rick/bg/9.png.webp": "ad31",
	"./images/rick/main/1.png.webp": "2f21",
	"./images/rick/main/2.png.webp": "bf9b",
	"./images/rick/main/3.png.webp": "ceab",
	"./images/rick/main/4.png.webp": "d036",
	"./images/rick/main/5.png.webp": "49e1",
	"./images/rick/main/6.png.webp": "eef8",
	"./images/rick/main/7.png.webp": "8771",
	"./images/rick/main/8.png.webp": "8a01",
	"./images/sf/bg/1.png.webp": "b343",
	"./images/sf/bg/10.png.webp": "ec5c",
	"./images/sf/bg/11.png.webp": "30c6",
	"./images/sf/bg/12.png.webp": "e289",
	"./images/sf/bg/13.png.webp": "ccb5",
	"./images/sf/bg/14.png.webp": "7e15",
	"./images/sf/bg/15.png.webp": "f070",
	"./images/sf/bg/16.png.webp": "ea02",
	"./images/sf/bg/2.png.webp": "f2a8",
	"./images/sf/bg/3.png.webp": "07ac",
	"./images/sf/bg/4.png.webp": "b2af",
	"./images/sf/bg/5.png.webp": "089b",
	"./images/sf/bg/6.png.webp": "6d50",
	"./images/sf/bg/7.png.webp": "b9ae",
	"./images/sf/bg/8.png.webp": "f779",
	"./images/sf/bg/9.png.webp": "2063",
	"./images/sf/main/1.png.webp": "7ec6",
	"./images/sf/main/2.png.webp": "7d76",
	"./images/sf/main/3.png.webp": "9900",
	"./images/sf/main/4.png.webp": "9eba",
	"./images/sf/main/5.png.webp": "c024",
	"./images/sf/main/6.png.webp": "aa3a",
	"./images/sf/main/7.png.webp": "8706",
	"./images/sf/main/8.png.webp": "3a51",
	"./images/sonic/bg/1.png.webp": "6953",
	"./images/sonic/bg/10.png.webp": "edf8",
	"./images/sonic/bg/11.png.webp": "1191",
	"./images/sonic/bg/12.png.webp": "ad39",
	"./images/sonic/bg/13.png.webp": "0cc1",
	"./images/sonic/bg/14.png.webp": "a33d",
	"./images/sonic/bg/15.png.webp": "5547",
	"./images/sonic/bg/16.png.webp": "6d508",
	"./images/sonic/bg/2.png.webp": "2fe6",
	"./images/sonic/bg/3.png.webp": "d3b5",
	"./images/sonic/bg/4.png.webp": "9a88",
	"./images/sonic/bg/5.png.webp": "ee23",
	"./images/sonic/bg/6.png.webp": "6bfd",
	"./images/sonic/bg/7.png.webp": "686b",
	"./images/sonic/bg/8.png.webp": "b4f9",
	"./images/sonic/bg/9.png.webp": "e3e2",
	"./images/sonic/main/1.png.webp": "9337",
	"./images/sonic/main/2.png.webp": "c854",
	"./images/sonic/main/3.png.webp": "d0d2",
	"./images/sonic/main/4.png.webp": "a181",
	"./images/sonic/main/5.png.webp": "6a5b",
	"./images/sonic/main/6.png.webp": "3a1c",
	"./images/sonic/main/7.png.webp": "21b6",
	"./images/sonic/main/8.png.webp": "9ccf",
	"./images/soulc/bg/1.png.webp": "a183",
	"./images/soulc/bg/10.png.webp": "bbe2",
	"./images/soulc/bg/11.png.webp": "7954",
	"./images/soulc/bg/12.png.webp": "0180",
	"./images/soulc/bg/13.png.webp": "e7a1",
	"./images/soulc/bg/14.png.webp": "0618",
	"./images/soulc/bg/15.png.webp": "e753",
	"./images/soulc/bg/16.png.webp": "705b",
	"./images/soulc/bg/2.png.webp": "2d56",
	"./images/soulc/bg/3.png.webp": "4164",
	"./images/soulc/bg/4.png.webp": "e5e3",
	"./images/soulc/bg/5.png.webp": "c3b5",
	"./images/soulc/bg/6.png.webp": "ceeb",
	"./images/soulc/bg/7.png.webp": "754f",
	"./images/soulc/bg/8.png.webp": "beb1",
	"./images/soulc/bg/9.png.webp": "694d",
	"./images/soulc/main/1.png.webp": "00c8",
	"./images/soulc/main/2.png.webp": "fdac",
	"./images/soulc/main/3.png.webp": "ef2d",
	"./images/soulc/main/4.png.webp": "9d6c",
	"./images/soulc/main/5.png.webp": "9678",
	"./images/soulc/main/6.png.webp": "de41",
	"./images/soulc/main/7.png.webp": "38e1",
	"./images/soulc/main/8.png.webp": "5de8",
	"./images/starfox/bg/1.png.webp": "db91",
	"./images/starfox/bg/10.png.webp": "2db7",
	"./images/starfox/bg/11.png.webp": "299c",
	"./images/starfox/bg/12.png.webp": "619e",
	"./images/starfox/bg/13.png.webp": "e478",
	"./images/starfox/bg/14.png.webp": "03c5",
	"./images/starfox/bg/15.png.webp": "ccfc",
	"./images/starfox/bg/16.png.webp": "286d",
	"./images/starfox/bg/2.png.webp": "eac1",
	"./images/starfox/bg/3.png.webp": "8992",
	"./images/starfox/bg/4.png.webp": "c58d",
	"./images/starfox/bg/5.png.webp": "f142",
	"./images/starfox/bg/6.png.webp": "10d7",
	"./images/starfox/bg/7.png.webp": "e914",
	"./images/starfox/bg/8.png.webp": "49ad",
	"./images/starfox/bg/9.png.webp": "766a",
	"./images/starfox/main/1.png.webp": "bdec",
	"./images/starfox/main/2.png.webp": "6f52",
	"./images/starfox/main/3.png.webp": "5111",
	"./images/starfox/main/4.png.webp": "bf4f",
	"./images/starfox/main/5.png.webp": "00d7",
	"./images/starfox/main/6.png.webp": "1903",
	"./images/starfox/main/7.png.webp": "2a9f",
	"./images/starfox/main/8.png.webp": "d636",
	"./images/tbbt/bg/1.png.webp": "cb58",
	"./images/tbbt/bg/10.png.webp": "9d88",
	"./images/tbbt/bg/11.png.webp": "6b68",
	"./images/tbbt/bg/12.png.webp": "a7d5",
	"./images/tbbt/bg/13.png.webp": "5b3d",
	"./images/tbbt/bg/14.png.webp": "72e3",
	"./images/tbbt/bg/15.png.webp": "cf62",
	"./images/tbbt/bg/16.png.webp": "c074",
	"./images/tbbt/bg/2.png.webp": "c5b1",
	"./images/tbbt/bg/3.png.webp": "1be6",
	"./images/tbbt/bg/4.png.webp": "ed4e",
	"./images/tbbt/bg/5.png.webp": "8e6a",
	"./images/tbbt/bg/6.png.webp": "a8ef",
	"./images/tbbt/bg/7.png.webp": "28fb",
	"./images/tbbt/bg/8.png.webp": "e5a6",
	"./images/tbbt/bg/9.png.webp": "3d66",
	"./images/tbbt/main/1.png.webp": "9cdc",
	"./images/tbbt/main/2.png.webp": "cc38",
	"./images/tbbt/main/3.png.webp": "20a7",
	"./images/tbbt/main/4.png.webp": "7095",
	"./images/tbbt/main/5.png.webp": "a68a",
	"./images/tbbt/main/6.png.webp": "b500",
	"./images/tbbt/main/7.png.webp": "1e78",
	"./images/tbbt/main/8.png.webp": "bb18",
	"./images/tekken/bg/1.png.webp": "77eb",
	"./images/tekken/bg/10.png.webp": "4e37",
	"./images/tekken/bg/11.png.webp": "43ee",
	"./images/tekken/bg/12.png.webp": "8038",
	"./images/tekken/bg/13.png.webp": "75c0",
	"./images/tekken/bg/14.png.webp": "2233",
	"./images/tekken/bg/15.png.webp": "558a",
	"./images/tekken/bg/16.png.webp": "deb0",
	"./images/tekken/bg/2.png.webp": "81b1",
	"./images/tekken/bg/3.png.webp": "9bd9",
	"./images/tekken/bg/4.png.webp": "de3e",
	"./images/tekken/bg/5.png.webp": "b5c5",
	"./images/tekken/bg/6.png.webp": "8681",
	"./images/tekken/bg/7.png.webp": "7939",
	"./images/tekken/bg/8.png.webp": "510d",
	"./images/tekken/bg/9.png.webp": "6817",
	"./images/tekken/main/1.png.webp": "46c7",
	"./images/tekken/main/2.png.webp": "62ca",
	"./images/tekken/main/3.png.webp": "1bb9",
	"./images/tekken/main/4.png.webp": "fe04",
	"./images/tekken/main/5.png.webp": "063b",
	"./images/tekken/main/6.png.webp": "8c68",
	"./images/tekken/main/7.png.webp": "1212",
	"./images/tekken/main/8.png.webp": "7e89",
	"./images/zelda/bg/1.png.webp": "022e",
	"./images/zelda/bg/10.png.webp": "e173",
	"./images/zelda/bg/11.png.webp": "b31f",
	"./images/zelda/bg/12.png.webp": "62fa",
	"./images/zelda/bg/13.png.webp": "8e25",
	"./images/zelda/bg/14.png.webp": "d5a9",
	"./images/zelda/bg/15.png.webp": "e330",
	"./images/zelda/bg/16.png.webp": "02bd",
	"./images/zelda/bg/2.png.webp": "a7a2",
	"./images/zelda/bg/3.png.webp": "e6ba",
	"./images/zelda/bg/4.png.webp": "3a78",
	"./images/zelda/bg/5.png.webp": "bb45",
	"./images/zelda/bg/6.png.webp": "9292",
	"./images/zelda/bg/7.png.webp": "7756",
	"./images/zelda/bg/8.png.webp": "3aeb",
	"./images/zelda/bg/9.png.webp": "f057",
	"./images/zelda/main/1.png.webp": "ae41",
	"./images/zelda/main/2.png.webp": "6d45",
	"./images/zelda/main/3.png.webp": "c767",
	"./images/zelda/main/4.png.webp": "6ddd",
	"./images/zelda/main/5.png.webp": "1492",
	"./images/zelda/main/6.png.webp": "3998",
	"./images/zelda/main/7.png.webp": "fb91",
	"./images/zelda/main/8.png.webp": "ec3c",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";